import { useEffect } from 'react';

const getAbsoluteUrl = (path) => {
  if (!path) return 'https://vengamambasafetynets.com/logo.png';
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const root = window.location.origin;
  return `${root}${path.startsWith('/') ? '' : '/'}${path}`;
};

export const useDocumentMeta = (title, description, image) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      
      // Update og:title
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.setAttribute('content', title);

      // Update twitter:title
      let twTitle = document.querySelector('meta[name="twitter:title"]');
      if (!twTitle) {
        twTitle = document.createElement('meta');
        twTitle.setAttribute('name', 'twitter:title');
        document.head.appendChild(twTitle);
      }
      twTitle.setAttribute('content', title);
    }
    
    if (description) {
      // Update standard description
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);

      // Update og:description
      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (!ogDesc) {
        ogDesc = document.createElement('meta');
        ogDesc.setAttribute('property', 'og:description');
        document.head.appendChild(ogDesc);
      }
      ogDesc.setAttribute('content', description);

      // Update twitter:description
      let twDesc = document.querySelector('meta[name="twitter:description"]');
      if (!twDesc) {
        twDesc = document.createElement('meta');
        twDesc.setAttribute('name', 'twitter:description');
        document.head.appendChild(twDesc);
      }
      twDesc.setAttribute('content', description);
    }

    // Dynamic Canonical URL
    const canonicalUrl = window.location.href;
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    // Update og:url
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', canonicalUrl);

    // Update twitter:url
    let twUrl = document.querySelector('meta[name="twitter:url"]');
    if (!twUrl) {
      twUrl = document.createElement('meta');
      twUrl.setAttribute('name', 'twitter:url');
      document.head.appendChild(twUrl);
    }
    twUrl.setAttribute('content', canonicalUrl);

    // Image (OG & Twitter)
    const imgUrl = getAbsoluteUrl(image);
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute('content', imgUrl);

    let twImage = document.querySelector('meta[name="twitter:image"]');
    if (!twImage) {
      twImage = document.createElement('meta');
      twImage.setAttribute('name', 'twitter:image');
      document.head.appendChild(twImage);
    }
    twImage.setAttribute('content', imgUrl);

  }, [title, description, image]);
};
